export const FORM_NAME = 'contactPage'
export const DEFAULT_SUBJECT = 'general_inquiry'
